// Owner: slides-present-export (plan §9.11). The presenter window of a presentation session
// (`openPresentation({ mode: 'presenter' })` opens it): it joins the session's BroadcastChannel and
// shows the presenter view of the show running in the other window.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PresenterWindow } from '../../../features/present/PresenterWindow';

export const Route = createFileRoute('/_public/present/presenter')({
  validateSearch: z.object({ session: z.string().min(8).max(80).catch('') }),
  component: function PresenterRoute() {
    const { session } = Route.useSearch();
    return <PresenterWindow session={session} />;
  },
});
